<template>
  <div class="handle-button">
    <el-button type="text" size="mini" @click="handleShow">设置要排除的店铺</el-button>
    <el-drawer :visible.sync="show" title="选择要排除的店铺" custom-class="set-tbl-shops-drawer" append-to-body>
      <div v-loading="load" class="set-tbl-shops-main">
        <div class="set-tbl-shops set-tbl-shops__left">
          <div class="set-tbl-shops__head" style="display: flex;align-items: center;justify-content: space-between">
            <div>
              请选择
              <span class="set-tbl-shops__head-tip" style="margin-right: 20px">最多显示50条，搜索关键词查找更多</span>
            </div>
            <el-input
              placeholder="搜索店铺"
              v-model="search_field"
              prefix-icon="el-icon-search"
              size="mini" style="width: 180px"
              clearable
            />
          </div>
          <div class="set-tbl-shops__part">
            <el-checkbox-group v-model="fields">
              <el-checkbox v-for="(item,item_i) in shops" :key="'checkbox'+item_i+item.value" :label="item.value"
                           @change="checked => eventChangeCheck(checked, item.value,item_i)"
                           :title="JSON.stringify(item)">
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="set-tbl-shops set-tbl-shops__right">
          <div class="set-tbl-shops__head" style="display: flex;align-items: center;justify-content: space-between">
            <div>
              已选择：{{ shops_checked.length }}
            </div>
            <el-tooltip content="清空" placement="bottom" effect="light">
              <el-button size="mini" type="text"
                         style="width: 28px;height: 28px;display: flex;align-items: center;justify-content: center;"
                         @click="clear">
                清空
              </el-button>
            </el-tooltip>
          </div>
          <div class="set-tbl-shops__part">
            <draggable
              v-model="shops_checked"
              group="site"
              animation="100"
              drag-class="dragClass"
              ghost-class="ghostClass"
              chosen-class="chosenClass"
              filter=".forbid"
              style="height: 100%"
            >
              <transition-group style="width: 100%; height: 100%; display: inline-block;overflow-y: auto">
                <div
                  v-for="(item,index) in shops_checked"
                  :key="`a-${index}`"
                  class="column"
                >
                  <div :title="`${item.sort||0}`">
                    <i class="el-icon-rank" />
                    {{ index + 1 }}、 {{ item.label }}
                  </div>
                  <i class="el-icon-close delete" @click="eventDel(index,item.value)" />
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button round @click="show = false">取 消</el-button>
        <el-button round type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { shopOptionsTrade } from '@/api/trade'

export default {
  name: 'TradeStatsChooseShop',
  value: 'ChooseShop',
  components: { draggable },
  props: {
    platform_code: {
      type: String,
      default() {
        return ''
      }
    },
    value: {
      type: String,
      default() {
        return ''
      }
    },
    month: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      show: false,
      load: false,
      search_field: null,
      check_all: {// 全选
        is_half: false,
        value: false
      },
      fields: [],
      shops: [],
      shops_checked: []
    }
  },
  watch: {
    search_field(keyword) {
      this.getShopOptions(keyword)
    }
  },
  created() {
    this.shops_checked = this.value ? JSON.parse(this.value) : []
    this.fields = this.value ? JSON.parse(this.value) : []
  },
  methods: {
    handleShow: async function() {
      this.search_field = null
      this.show = true
      const loading = this.$loading({
        lock: true,
        body: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      await this.getShopOptions()
      loading.close()
    },
    clear: function() {
      this.shops_checked = []
      this.fields = []
    },
    handleSubmit: async function() {
      // const fields = this.shops_checked.map(_ => {
      //   return { value: _.value, display: true }
      // })
      // await updateTableDisplay({ type: 'ad_order', fields })
      this.show = false
      this.$emit('success', this.shops_checked)
    },
    /**
     * 不改变排序顺序
     * @param check
     * @param value
     * @param item_i
     */
    eventChangeCheck: function(check, value, item_i) {
      // eslint-disable-next-line no-console
      // console.log(item_i)
      if (check) {
        // 选中
        const tmp = this.shops.find(_ => _.value === value)
        if (tmp) {
          const posIndex = this.findMyPos(item_i)
          this.shops_checked.splice(posIndex, 0, tmp)
          // this.shops_checked.push(tmp)
        }
      } else {
        // 取消选中
        const index = this.shops_checked.findIndex(_ => _.value === value)
        this.shops_checked.splice(index, 1)
      }
    },
    findMyPos(index) {
      if (index === 0) {
        return 0
      }
      const len = this.shops_checked.length
      if (len === 0) {
        return 0
      }
      //上一列
      const preCol = this.shops[index - 1]
      if (!preCol) {
        return 0
      }
      // 并且已勾选，则在上一列后加当前列
      const preIndex = this.shops_checked.findIndex(value => value.value === preCol.value)
      if (preIndex > -1) {
        // eslint-disable-next-line no-console
        // console.log('上一列', preCol.title, preIndex)
        //若列号小于当前列
        if (preIndex < index) {
          // eslint-disable-next-line no-console
          // console.log("============= 若前一列现在的位置靠前，则选定===============")
          return preIndex + 1
        } else {

          // eslint-disable-next-line no-console
          // console.log("============= 若前一列现在的位置靠后，则排除===============")
          return this.findMyPos(index - 1)
        }
      } else {
        //往前找，直到没有
        return this.findMyPos(index - 1)
      }
    },

    getShopOptions: async function(keyword) {
      this.shops = await shopOptionsTrade({
        month: this.month,
        platform_code: this.platform_code,
        keyword
      })
    },
    eventDel: function(index, value) {
      this.shops_checked.splice(index, 1)
      const fields_index = this.fields.findIndex(_ => _ === value)
      this.fields.splice(fields_index, 1)
    }
  }
}
</script>

<style lang="scss">
.set-tbl-shops-drawer {
  width: 1008px !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
    background: #e8ebf2;
  }
  .set-tbl-shops-main {
    display: flex;
    flex-direction: row;
    gap: 20px;
    height: calc(100% - 106px);
    margin-top: 20px;
  }

  .set-tbl-shops {
    border-radius: 16px;
    background: #fff;

    &__head {
      padding: 16px 24px;
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      border-bottom: 1px solid #e4e7f0;

      &-tip {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-left: 12px;
      }
    }

    &__part {
      padding: 16px 24px;
      height: calc(100% - 115px);
      overflow-y: auto;


      .el-checkbox-group {
        //height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 5px 12px;

        .el-checkbox.active {
          background-color: #ffeef3;
        }

        .el-checkbox {
          padding: 4px 10px;
          border-radius: 6px;
          margin-right: unset;

          .el-checkbox__label {
            font-size: 12px;
          }
        }
      }

      .column.chosenClass {
        background-color: #ffeef3;
        color: #fe346e;
      }

      .column {
        border: 1px solid #e4e7f0;
        border-radius: 8px;
        padding: 0 8px;
        font-size: 12px;
        height: 28px;
        line-height: 1.2;
        margin-bottom: 12px;
        cursor: move;
        transition: border-color 0.2s;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .el-icon-rank {
          font-size: 12px;
          margin-right: 4px;
        }

        .delete {
          color: #ff3176;
          cursor: pointer;
          font-size: 14px;
          opacity: 0;
          transform: scale(.85);
          transition: all var(--duration);
        }
      }

      .column:hover {
        border-color: #ff3176;

        .delete {
          opacity: 1;
        }
      }
    }
  }

  .set-tbl-shops__left {
    width: calc(100% - 320px);
  }

  .set-tbl-shops__right {
    width: 300px;
    position: relative;
  }

  .set-tbl-shops__right:after, .set-tbl-shops__right:before {
    //-o-border-image: linear-gradient(45deg,transparent,#E03F3D) 1;
    border-image: linear-gradient(45deg, transparent, #E03F3D) 1;
    border-radius: 2px;
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: " ";
    height: 10px;
    left: -20px;
    margin-top: -8px;
    opacity: .8;
    position: absolute;
    top: 50%;
    transform: rotate(45deg);
    width: 10px;
  }

  .set-tbl-shops__right:before {
    margin-left: 4px;
  }

  .set-tbl-shops__right:after {
    margin-left: -4px;
  }
}
</style>
